import React from 'react'
import { Stack } from '@mantine/core'
import LabeledContainer from '../../../components/LabeledContainer'
import ReportWrapper from '../ReportWrapper'
import PageEmpty from '../../../components/PageEmpty'
import CompanySummary from './CompanySummary'
import CompanyList from './CompanyList'
import { CdDataRelationCompanyData, CompanyItem } from './types'

interface CdDataRelationCompanyInformationProps {
  data: any
  title: string
  sectionIndex?: string
}

const CdDataRelationCompanyInformation: React.FC<CdDataRelationCompanyInformationProps> = ({ data, title }) => {
  const jsonData: CdDataRelationCompanyData = JSON.parse(data.cddata_relation_companies ?? '{}')
  const companies: CompanyItem[] = jsonData?.queryResult?.items || []

  return (
    <ReportWrapper>
      <LabeledContainer title={title} />
      <Stack>
        {companies.length === 0 ? (
          <PageEmpty />
        ) : (
          <>
            <CompanySummary companies={companies} />
            <CompanyList companies={companies} />
          </>
        )}
      </Stack>
    </ReportWrapper>
  )
}

export default CdDataRelationCompanyInformation
